<h2 mat-dialog-title>
  <mat-icon svgIcon="sell_outlined"></mat-icon>
  Rediger prispolitik
</h2>
<form [formGroup]="formGroup" (ngSubmit)="savePricePolicy()">
  <button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
    <mat-icon>close</mat-icon>
  </button>
  <mat-dialog-content class="dialog-content">
    @if (!canHaveDynamicPricePolicy) {
      <div class="form-row">
        <ok-feedback-info role="status">{{ dynamicPricePolicyWarning }}</ok-feedback-info>
      </div>
    }
    <div class="form-row">
      <adm-adm-price-policy-typeahead
        [initialPricePolicyId]="currentPricePolicyId?.toString() ?? null"
        [organizationId]="data.organizationId"
        [includeGlobal]="true"
        [alwaysIncludeDynamic]="canHaveDynamicPricePolicy"
        [type]="data.pricePolicyType"
        (itemSelected)="onPricePolicySelected($event)" />
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-dialog-close type="button" mat-button>Annuller</button>
    <button
      type="submit"
      [disabled]="formGroup.invalid || loading || currentPricePolicyId === pricePolicyId.value"
      [class.spinner]="loading"
      mat-flat-button>
      Gem
    </button>
  </mat-dialog-actions>
</form>
